export default __webpack_public_path__ + "static/media/spotify.91a40dc3.png";